export default "__VITE_ASSET__d7488066__"